var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from "react";
import { Transition } from "react-transition-group";
import classNames from "classnames";
import AccordionHeader from "./AccordionHeader";
// styles
import "./accordion.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-accordion-content",
    open: false,
    disabled: false,
    iconOnClose: "arrow-up",
    iconOnOpen: "arrow-down",
};
const DEFAULT_ANIMATION_TIME = 350;
// Inspired from https://github.com/reactstrap/reactstrap/blob/5108720a117af3a3742bb0c39b49ef32a48313b0/src/Collapse.js
const transitionStatusToClassHash = {
    entering: "collapsing",
    entered: "collapse open",
    exiting: "collapsing",
    exited: "collapse",
};
const AccordionContent = React.forwardRef((_a, ref) => {
    var { className, panelClassName, title, headerComponent, children, open, disabled, onClick, iconOnClose, iconOnOpen, animationTimeMillis, animationExitTimeMillis } = _a, rest = __rest(_a, ["className", "panelClassName", "title", "headerComponent", "children", "open", "disabled", "onClick", "iconOnClose", "iconOnOpen", "animationTimeMillis", "animationExitTimeMillis"]);
    const classList = classNames("tecma-accordion-content", className);
    const panelClassList = classNames("tecma-accordion-content-panel", { open }, panelClassName);
    const animationTime = open
        ? animationTimeMillis || DEFAULT_ANIMATION_TIME
        : animationExitTimeMillis || animationTimeMillis || DEFAULT_ANIMATION_TIME;
    const [contentHeight, setContentHeight] = useState(open ? null : 0);
    const contentRef = useRef(null);
    return (_jsxs("div", Object.assign({ ref: ref, className: classList }, rest, { children: [_jsx(AccordionHeader, { title: title, isOpen: open, onClick: onClick, iconOnClose: iconOnClose, iconOnOpen: iconOnOpen, disabled: disabled, headerComponent: headerComponent }), _jsx(Transition, { in: open, nodeRef: contentRef, onEntering: () => {
                    var _a;
                    const height = (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
                    setContentHeight(height !== null && height !== void 0 ? height : null);
                }, onEntered: () => {
                    setContentHeight(null);
                }, onExiting: () => {
                    var _a;
                    const height = (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
                    setContentHeight(height !== null && height !== void 0 ? height : null);
                }, onExited: () => {
                    setContentHeight(0);
                }, timeout: {
                    appear: animationTime,
                    enter: animationTime,
                }, children: (status) => {
                    return (_jsx("div", { className: classNames("tecma-accordion-content-panel-wrapper", transitionStatusToClassHash[status]), style: Object.assign({ transition: `height ${animationTime}ms ease-in-out` }, (contentHeight != null && {
                            height: contentHeight !== null && contentHeight !== void 0 ? contentHeight : "unset",
                        })), children: _jsx("div", { "data-testid": "tecma-accordion-content-panel", className: panelClassList, ref: contentRef, children: children }) }));
                } })] })));
});
AccordionContent.defaultProps = defaultProps;
export default AccordionContent;
